import { useMemo } from "react";
import useSWR from "swr";

import { apiUsersEndpoints } from "@api/Endpoints";

import { fetcher } from "@utils/swrUtils";

import { AzureApplicationUserModel } from "../models/api-users-models";

export function useGetApiUserById(apiUserId?: string) {
  const url = apiUserId ? apiUsersEndpoints.getApiUserById(apiUserId) : null;

  const { data, error, isLoading } = useSWR<AzureApplicationUserModel, Error>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(
    () => ({ apiUser: data, isLoading, error }),
    [data, isLoading, error]
  );
}
